export const GET_CROWD_DATA = 'GET_CROWD_DATA' //获取八大类数据
export const GET_WARN_DATA = 'GET_WARN_DATA' //获取三色预警图表数据
export const GET_SEX_DATA = 'GET_SEX_DATA' //获取性别
export const GET_AGE_DATA = 'GET_AGE_DATA' //获取年龄

export const GET_WARN_LIST = 'GET_WARN_LIST' //获取三色预警列表数据
export const GET_TASK_LIST = 'GET_TASK_LIST' //获取任务清单列表数据

// *****咨询师大屏模块*****//
export const GET_KEY_WORD_LIST = 'GET_KEY_WORD_LIST' //获取关键字排行
export const GET_POUR_THEME_LIST = 'GET_POUR_THEME_LIST' // 获取倾诉主题
export const GET_DOCTOR_CLASS_LIST = 'GET_DOCTOR_CLASS_LIST' //咨询师类别
export const GET_DOCTOR_LV_LIST = 'GET_DOCTOR_LV_LIST' //咨询师级别
export const GET_DOCTOR_TASK_TYPE = 'GET_DOCTOR_TASK_TYPE' //任务管理类别